import { Component, OnInit, Input,Output, EventEmitter,} from '@angular/core';

@Component({
  selector: 'app-hcptooltip',
  templateUrl: './hcptooltip.component.html',
  styleUrls: ['./hcptooltip.component.scss']
})
export class HcptooltipComponent implements OnInit {
  @Input() close: string;
  @Input() message: string;
  @Input() path: string;
  @Output() buttonWasClicked = new EventEmitter<void>();
  constructor() { }
  hidepopup(){
    this.buttonWasClicked.emit();
  }
  ngOnInit() {
  }

}
